import {
  FormControl,
  FormHelperText,
  FormLabel,
  Typography
} from '@mui/material';

import { appFormUtil } from 'modules/common';
import { FormFileUploadField } from 'modules/components/layer00';
import { UploadAttachmentCard } from 'modules/components/layer02';
import * as ds from './dataService';
import React, { useEffect } from 'react';


export type StyledFileUploadFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  formFieldPropertyName: keyof appFormUtil.InferReturn<T>['formState'];
  formLabel?: string;
  required?: boolean;
  validationErrorMessage?: string;
};

export const FC = <T extends object>(props: StyledFileUploadFieldProps<T>) => {
  const [
    fnQuery,
    queryTuple
  ] = ds.useQuery();



  useEffect(() => {
    if (!queryTuple.loading && queryTuple.data.fileName) {
      props.form.dispatch({
        type: 'ADD_ITEM_TO_ARRAY',
        payload: {
          key: props.formFieldPropertyName as keyof appFormUtil.IArrayFields<T> & string,
          value: {
            id: queryTuple.data.id,
            fileName: queryTuple.data.fileName,
            formattedFileSize: queryTuple.data.sizeBytes
          } as appFormUtil.IPairs<T>
        }
      });
    }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [queryTuple]);

  return (
    <FormControl
      fullWidth
      required={props.required}
      error={
        props.validationErrorMessage
        && props.validationErrorMessage?.length > 1
          ? true
          : false
      }
    >
      <FormLabel
        sx={{
          marginBottom: '.75rem'
        }}
      >
        <Typography
          variant='formLabel'
        >
          {props.formLabel}
        </Typography>
      </FormLabel>

      <FormFileUploadField.FC
        onUploadedFile={async (apiFileId) => {
          fnQuery(apiFileId);

        }}
      >
        {(handleClick, isLoading) => {
          return (
            <UploadAttachmentCard.FC
              handleClick={() => {
                handleClick();

              }}
              isLoading={queryTuple.loading || isLoading}
            />
          );
        }}
      </FormFileUploadField.FC>
      {
        props.validationErrorMessage && props.validationErrorMessage.length > 1
          ? (
            <FormHelperText variant='standard'>
              {props.validationErrorMessage}
            </FormHelperText>
          )
          : (<></>)
      }
    </FormControl>
  );
};
